import { CREATE_USER } from '../config';

const reducer = (state = null, action) => {
    switch (action.type) {       
        case CREATE_USER:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;